import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import Logo from "@/components/Logo";
import { ArrowRight } from "@phosphor-icons/react";

export default function Register() {
    const { register } = useAuth();
    const nav = useNavigate();
    const [form, setForm] = useState({ name: "", email: "", password: "" });
    const [err, setErr] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setErr(""); setLoading(true);
        try {
            await register(form.email, form.password, form.name);
            nav("/dashboard", { replace: true });
        } catch (e) { setErr(e.message); }
        finally { setLoading(false); }
    };

    return (
        <div className="min-h-screen grid md:grid-cols-2" data-testid="register-page">
            <div className="flex items-center justify-center p-8 md:p-16 order-2 md:order-1">
                <form onSubmit={submit} className="w-full max-w-sm" data-testid="register-form">
                    <div className="uppercase-tag mb-3">Inscription · gratuit</div>
                    <h2 className="font-display font-black tracking-tighter text-3xl">Commencez à sauver.</h2>
                    <p className="mt-2 text-sm text-zinc-500">Déjà un compte ? <Link to="/login" className="text-fzblue underline">Se connecter</Link></p>

                    <div className="mt-8 space-y-4">
                        <div>
                            <label className="uppercase-tag block mb-2">Prénom</label>
                            <input data-testid="register-name" required minLength={1} value={form.name}
                                onChange={(e) => setForm({ ...form, name: e.target.value })}
                                className="w-full border border-zinc-300 px-4 py-3 focus:outline-none focus:border-fzblue" placeholder="Camille" />
                        </div>
                        <div>
                            <label className="uppercase-tag block mb-2">Email</label>
                            <input data-testid="register-email" required type="email" value={form.email}
                                onChange={(e) => setForm({ ...form, email: e.target.value })}
                                className="w-full border border-zinc-300 px-4 py-3 focus:outline-none focus:border-fzblue" placeholder="vous@exemple.fr" />
                        </div>
                        <div>
                            <label className="uppercase-tag block mb-2">Mot de passe (6 caractères min)</label>
                            <input data-testid="register-password" required type="password" minLength={6} value={form.password}
                                onChange={(e) => setForm({ ...form, password: e.target.value })}
                                className="w-full border border-zinc-300 px-4 py-3 focus:outline-none focus:border-fzblue" placeholder="••••••••" />
                        </div>
                        {err && <div data-testid="register-error" className="text-fzred text-sm">{err}</div>}
                        <button data-testid="register-submit" type="submit" disabled={loading} className="btn-primary w-full disabled:opacity-60">
                            {loading ? "Création..." : "Créer mon compte gratuit"} <ArrowRight size={16} />
                        </button>
                        <p className="text-xs text-zinc-500">En créant un compte, vous acceptez nos CGU et notre politique de confidentialité.</p>
                    </div>
                </form>
            </div>
            <div className="hidden md:flex bg-fzblue text-white p-12 flex-col justify-between order-1 md:order-2 relative overflow-hidden">
                <Link to="/" className="text-white"><Logo variant="blue-bg" /></Link>
                <div className="relative z-10">
                    <div className="uppercase-tag text-blue-200 mb-4">Beta ouverte</div>
                    <h1 className="font-display font-black tracking-tighter text-5xl leading-[1]">
                        Rejoignez les 500 premiers.<br />
                        <span className="text-white/70">Gratuit à vie.</span>
                    </h1>
                    <ul className="mt-8 space-y-3 text-white/90">
                        <li>✓ Frigo intelligent illimité</li>
                        <li>✓ Recettes IA GPT-5.2 en direct</li>
                        <li>✓ Score hygiène automatisé</li>
                        <li>✓ Impact CO₂ personnel</li>
                    </ul>
                </div>
                <div className="text-xs text-blue-200 font-mono">monfrigozero.app · Beta 2026</div>
                <div className="absolute inset-0 grid-lines opacity-10 pointer-events-none" />
            </div>
        </div>
    );
}
